import Icon from '../components/Icon.vue'

Icon.register({
  hospital: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 492v20h-448v-20c0-6.6 5.4-12 12-12h20v-360c0-13.3 10.7-24 24-24h88v-72c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v72h88c13.3 0 24 10.7 24 24v360h20c6.6 0 12 5.4 12 12zM308 192h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM140 256h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zM244 384h-40c-6.6 0-12 5.4-12 12v84h64v-84c0-6.6-5.4-12-12-12zM308 288h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM192 300c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zM182 96h26v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26h26c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6h-26v-26c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v26h-26c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6z'
      }
    ]
  }
})
